import intlTelInput from 'intl-tel-input'

document.addEventListener("turbolinks:load", function() {
  document.querySelectorAll('.tel-input').forEach((element) => intlTelInput(element, {
    preferredCountries: ["bj", "cm", "ci", "sn"]
  }));
})
